import { Box, Button, Container, Divider, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const TermsAndConditionsPage = () => {
  const navigate = useNavigate();

  return (
    <Container maxWidth="md" sx={{ py: 6 }}>
      <Box
        sx={{
          border: 1,
          borderColor: 'divider',
          borderRadius: '16px',
          overflow: 'hidden',
          bgcolor: 'background.paper',
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.05)',
          p: { xs: 3, md: 6 },
        }}
      >
        <Button
          onClick={() => navigate(-1)}
          variant="text"
          size="small"
          sx={{ mb: 4, textTransform: 'none', fontWeight: 600 }}
        >
          &larr; Back
        </Button>

        <Typography variant="h4" sx={{ fontWeight: 800, mb: 1, color: 'text.primary' }}>
          Terms & Conditions
        </Typography>
        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 4 }}>
          Last Updated: June 14, 2026
        </Typography>

        <Divider sx={{ mb: 4 }} />

        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
          <Box>
            <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
              1. Acceptance of Terms
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.7 }}>
              By accessing and using Minotii, you agree to comply with and be bound by these Terms and Conditions.
              If you do not agree with these terms, please do not access or use the platform.
            </Typography>
          </Box>

          <Box>
            <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
              2. User Accounts and Authentication
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.7 }}>
              You may access certain features of the platform using third-party sign-in providers, such as Google OAuth.
              You are responsible for maintaining the confidentiality of your credentials and for all activities that occur
              under your account. You agree to notify us immediately of any unauthorized use of your account.
            </Typography>
          </Box>

          <Box>
            <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
              3. Permitted Use and License
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.7 }}>
              Subject to your compliance with these Terms, Minotii grants you a limited, non-exclusive, non-transferable,
              and revocable license to access and use the platform for your internal business operations, matching your
              active tenant configuration and subscription status.
            </Typography>
          </Box>

          <Box>
            <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
              4. Prohibited Activities
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.7 }}>
              You agree not to engage in any of the following prohibited activities:
            </Typography>
            <Box component="ul" sx={{ pl: 3, mt: 1, display: 'flex', flexDirection: 'column', gap: 0.5 }}>
              <Typography component="li" variant="body2" color="text.secondary">
                Using the platform for any illegal purpose or in violation of any local, state, national, or international law.
              </Typography>
              <Typography component="li" variant="body2" color="text.secondary">
                Interfering with or damaging the integrity or performance of the platform or the data contained therein.
              </Typography>
              <Typography component="li" variant="body2" color="text.secondary">
                Attempting to gain unauthorized access to the platform or its related systems or networks.
              </Typography>
              <Typography component="li" variant="body2" color="text.secondary">
                Reverse engineering or attempting to extract the source code of the software.
              </Typography>
            </Box>
          </Box>

          <Box>
            <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
              5. Disclaimer of Warranties and Limitation of Liability
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.7 }}>
              The platform is provided "as is" and "as available" without warranty of any kind. Minotii disclaims all warranties,
              express or implied. In no event shall Minotii be liable for any direct, indirect, incidental, special,
              consequential, or exemplary damages arising out of or in connection with your use of the platform.
            </Typography>
          </Box>

          <Box>
            <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
              6. Modifications to Terms
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.7 }}>
              We reserve the right, at our sole discretion, to modify or replace these Terms at any time. We will provide notice of
              any material changes by updating the last updated date. Continued use of the platform after changes constitutes your
              acceptance of the revised terms.
            </Typography>
          </Box>
        </Box>
      </Box>
    </Container>
  );
};

export default TermsAndConditionsPage;
